// extracted by mini-css-extract-plugin
export default {"entrance":"Entrance_entrance__oQ25k","button":"Entrance_button__tBugm","buttonContainer":"Entrance_buttonContainer__sw6EQ","loadFile":"Entrance_loadFile__iODXb"};